var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory81(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 293,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0,
    width: 307,
    height: 293
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0,
    width: 307,
    height: 293
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-4 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.832 57.6168 217.019 17.6424C217.019 17.6424 207.206 2.02376 191.52 11.7877 175.852 21.5336 185.665 37.1702 185.665 37.1702L217.435 98.0595C217.435 98.0595 220.037 111.895 200.845 96.4202 192.478 89.6827 197.285 93.4838 197.285 93.4838L189.333 86.9806 90.1014 5.77079C90.1014 5.77079 77.2885-7.70412 65.5419 6.52741 53.8314 20.7769 69.5719 30.685 69.5719 30.685L163.418 107.535C161.25 109.697 154.708 117.155 152.575 119.479L52.1507 37.3323C52.1507 37.3323 39.3198 23.8394 27.6093 38.0709 15.8627 52.3205 31.6212 62.2285 31.6212 62.2285L132.01 144.411C130.148 146.933 125.45 152.986 123.715 155.472L37.115 84.6026C37.115 84.6026 24.2841 71.1277 12.5736 85.3592 0.80891 99.6088 16.5855 109.535 16.5855 109.535L108.643 184.908C107.486 188.114 102.083 196.545 101.234 199.68L34.8741 145.42C34.8741 145.42 22.0613 131.873 10.3508 146.158-1.39584 160.408 14.3627 170.316 14.3627 170.316L121.528 258.011 128.666 263.884C176.014 302.633 245.934 295.788 284.806 248.589 320.426 205.3 317.643 143.15 280.469 103.23 267.295 89.1423 255.891 73.4516 244.832 57.6168Z",
    fill: "#F4900C",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.151 100C205.151 100 159.071 159.631 213.752 234.232 217.52 239.36 227.081 236.859 223.011 230.849 218.568 224.3 174.141 160.746 215.903 103.869 215.903 103.869 209.132 103.023 205.151 100Z",
    fill: "#B55005",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory81);
export default __webpack_public_path__ + "static/media/accessory8-1.e351925f3efc2f626f16f85071c5460a.svg";
export { ForwardRef as ReactComponent };